import { environment } from '../../../environments/environment.local';

export const clientUriTemplate = (clientId?: string): string => {
  return `${environment.API.CLIENTS_URI}/${clientId}`;
};
